import React from "react";

// @ts-ignore
import styled from "styled-components";
import QRCode from "./QRCode";
import { ICertificate } from "../../../types";
import CertificateDemographic from "./certificate-demographics";

const Logo = require("../../../assets/Logo.png");

const CertificateContent: React.FC<{ certificate: ICertificate }> = ({
  certificate,
}) => {
  const { signature } = certificate;
  return (
    <>
      <HeaderContainer>
        <p>REF:{`${certificate.epiNo}-${certificate.createdAt}`}</p>
        <p>CREATED AT:{certificate.createdAt}</p>
      </HeaderContainer>
      <CertificateContainer>
        <LogoContainer>
          <img src={Logo} alt="MW Court of arms" />
          <h1>Malawi Government</h1>
        </LogoContainer>
        <h2>COVID19</h2>
        <h3>Vaccination Certificate</h3>
        <CertificateDemographic certificate={certificate} />
        <QRCodeContainer>
          {QRCode(
            `https://covid19.health.gov.mw/covax/validate-certificate?sg=${signature}`
          )}
        </QRCodeContainer>
      </CertificateContainer>
      <FooterContainer>
        www.covid19.health.mw | Digital Health Division, Department of Planning
        and Policy Development, Ministry of Health - Malawi
      </FooterContainer>
    </>
  );
};
export default CertificateContent;

const FooterContainer = styled.p`
  font-size: 8px;
  color: #444444;
`;
const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 8px;
  color: #444444;
  align-self: flex-start;
  width: 100%;
`;

const CertificateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid #444444;
  padding: 10px;
  & > h1,
  h3 {
    margin-bottom: 0px;
    text-transform: uppercase;
  }
`;

const QRCodeContainer = styled.div`
  margin-top: 2em;
  margin-bottom: 2em;
  & > img {
    height: 200px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
  & > img {
    height: 150px;
  }
  & > p {
    margin: 0;
  }
  & > h1 {
    margin: 0;
  }
`;
